module.exports = __webpack_public_path__ + "static/thumbnail-aeeef7130a1000f9da41a6ec0187c587.png";